import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../state/AuthContext';

const ADMIN_PERMISSION = 'chat.admin';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, currentUser, status } = useAuth();
  const location = useLocation();

  if (status === 'loading' || status === 'idle') {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900">
        <p className="text-gray-400">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated || !currentUser) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  const permissions = currentUser.permissions || [];
  if (!permissions.includes(ADMIN_PERMISSION)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default AdminRoute;
